import { BaseService } from './base.service';

export interface PendingRequestResult {
  hasPendingRequest: boolean;
}

export interface BatchPendingRequestResult {
  [targetMemberId: string]: PendingRequestResult;
}

export class MemberPermissionsService extends BaseService {
  constructor() {
    super('');
  }

  async checkPendingAccessRequest(targetMemberId: string): Promise<PendingRequestResult> {
    return this.get<PendingRequestResult>(`/member-permissions/check-pending-request/${targetMemberId}`);
  }

  async checkPendingAccessRequestsBatch(targetMemberIds: string[]): Promise<BatchPendingRequestResult> {
    return this.post<BatchPendingRequestResult>(`/member-permissions/check-pending-requests-batch`, { targetMemberIds });
  }

  async getPendingAccessTokensForMember(memberId: string): Promise<{ tokens: any[] }> {
    return this.get<{ tokens: any[] }>(`/member-permissions/member-requesting-access?memberId=${memberId}`);
  }

  async requestAccess(data: { memberId: string; familyId: string; familyMemberId: string }): Promise<{ success: boolean }> {
    return this.post<{ success: boolean }>(`/member-permissions/request-access`, data);
  }

  async revokeInvite(data: { memberId: string; familyId: string; familyMemberId: string; token?: string }): Promise<{ success: boolean }> {
    return this.post<{ success: boolean }>(`/member-permissions/revoke-invite`, data);
  }

  async revokeAccess(data: { memberId: string; familyId: string; familyMemberId: string }): Promise<void> {
    return this.post<void>(`/member-permissions/revoke-access`, data);
  }
}

export const memberPermissionsService = new MemberPermissionsService();
